module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE4IDE3Ij4KICAgIDxwYXRoIGZpbGw9IiM4ODhCOTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEgOWgxMy41NjRsLTUuMzMgNS4zMmExLjAyIDEuMDIgMCAwIDAtLjAwOCAxLjQzIDEuMDAxIDEuMDAxIDAgMCAwIDEuNDE1LjAxNmw3LjA2Mi02Ljk5NmEuOTk3Ljk5NyAwIDAgMCAuMDA5LTEuNDEybC03LTcuMDYxQS45OTkuOTk5IDAgMCAwIDkuMjk3LjI4OWEuOTYyLjk2MiAwIDAgMC0uMDA5IDEuMzgyTDE0LjYwNiA3SDFhMSAxIDAgMSAwIDAgMiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right-arrow.svg
// module id = v2Kl
// module chunks = 6 16 143 161